import {
    INotificationChannel,
    INotificationChannelCreateDto,
    INotificationChannelUpdateDto,
    NotificationChannelType,
} from "@lib";
import { Modal } from "@core/components/alt-ui/modal";
import { Button, Control, Panel, PasswordBox, TextBox } from "@core/components/alt-ui/controls";

export type NotificationTelegramBotModalContext = {
    channel?: INotificationChannel;
    createHandler?: (dto: INotificationChannelCreateDto) => Promise<boolean>;
    updateHandler?: (channelId: string, dto: INotificationChannelUpdateDto) => Promise<boolean>;
};

export class NotificationTelegramBotModal extends Modal<NotificationTelegramBotModalContext> {
    private tbName!: TextBox;
    private pbToken!: PasswordBox;

    private footer!: Panel;
    private btSave!: Button;

    private context: NotificationTelegramBotModalContext | null = null;

    public constructor() {
        super("notification-telegram-bot-modal", "Уведомления в Telegram");
        this.initializeControls();
    }

    public show(context?: NotificationTelegramBotModalContext): Promise<void> {
        this.context = context ?? null;
        this.initializeControls();

        if (context?.channel) {
            this.populateControls(context.channel);
        }

        return super.show();
    }

    protected initializeControls(): void {
        this.tbName = new TextBox();
        this.tbName.id = "notification-telegram-bot.name";
        this.tbName.label = "Название";
        this.tbName.validation = "required";

        this.pbToken = new PasswordBox();
        this.pbToken.id = "notification-telegram-bot.token";
        this.pbToken.label = "Токен бота";
        this.pbToken.help =
            "Токен выдаётся при создании бота и выглядит примерно так: 8123456789:AAHffocMN15IgFR5_Oxjhj2FgdPGbOYccm8";
        this.pbToken.validation = "required";

        //

        this.btSave = new Button();
        this.btSave.id = "clientSource.save";
        this.btSave.text = "Сохранить";
        this.btSave.addClickHandler(() => this.save());

        this.footer = new Panel();
        this.footer.class = "flex justify-end mt-2";
        this.footer.addControl(this.btSave);
    }

    private populateControls(channel: INotificationChannel): void {
        this.tbName.text = channel.name;
        this.pbToken.text = "";
    }

    public get controls(): Control[] {
        return [this.tbName, this.pbToken, this.footer];
    }

    private async cancel(): Promise<void> {
        this.hide();
    }

    private async save(): Promise<void> {
        const valid = await this.validate();

        if (!valid || !this.context) {
            return;
        }

        const result = this.context.channel ? await this.update(this.context.channel) : await this.create();

        if (result) {
            this.hide(result);
        }
    }

    private async create(): Promise<boolean> {
        if (!this.context?.createHandler) {
            return false;
        }

        const index = this.pbToken.text.indexOf(":");
        const key = index > 0 ? this.pbToken.text.substring(0, index) : undefined;

        const dto: INotificationChannelCreateDto = {
            type: NotificationChannelType.TelegramCustomBot,
            name: this.tbName.text,
            key: key,
            secret: this.pbToken.text,
        };

        return await this.context.createHandler(dto);
    }

    private async update(channel: INotificationChannel): Promise<boolean> {
        if (!this.context?.updateHandler) {
            return false;
        }

        const index = this.pbToken.text.indexOf(":");
        const key = index > 0 ? this.pbToken.text.substring(0, index) : undefined;

        const dto: INotificationChannelUpdateDto = {
            name: this.tbName.text,
            key: key,
            secret: this.pbToken.text,
        };

        return await this.context.updateHandler(channel.id, dto);
    }
}
